<img src="/assets/images/paybevLogoGreen.png" width="162" height="67" class="p-1" />
<div nz-row class="center p-3">
    <div nz-col nzSpan="12" nzOffset="6" class="splitbox mobile-none">
        <h1>Under Maintenance</h1>
        <hr>
        <img class="login-right-img" src="/assets/images/Maintenance.png" />
        <p class="p-1">Engineers are doing scheduled maintenance, kindly visit after some time.</p>
        <p class="p-1">{{_cS.underMaintenanceDesc}}</p>
        <a nz-button routerLink="/" (click)="clearStorange()" [nzType]="'primary'" style="display: unset;">Back to Login
            Page</a>
    </div>
</div>